<div class="link-options">
  @if (title) {
    <div class="title">{{ title }}</div>
  }
  <div class="subtitle">{{ subtitle }}</div>
  @if (!hideLink) {
    <div
      class="invite-link celo-elipsis celo-cursor-pointer"
      matRipple
      (click)="linkClick.emit(link)"
    >
      <div class="celo-link" target="_blank">
        {{ link ? link : linkFallback }}
      </div>
    </div>
  }
  <div class="link-buttons">
    @if (!disableEmailInvite) {
      <div>
        @if (link) {
          <a (click)="shareClick.emit()">
            <button mat-button class="celo-hoverable">
              <div class="content">
                <mat-icon svgIcon="email_outline"></mat-icon>
                <span>Invite via email</span>
              </div>
            </button>
          </a>
        }
        @if (!link) {
          <a (click)="error()">
            <button mat-button class="celo-hoverable">
              <div class="content">
                <mat-icon svgIcon="email_outline"></mat-icon>
                <span>Invite via email</span>
              </div>
            </button>
          </a>
        }
      </div>
    }
    <div>
      <button mat-button class="celo-hoverable" (click)="copyClick.emit(link)">
        <div class="content">
          <mat-icon>content_copy</mat-icon>
          <span>&nbsp;&nbsp;{{ copyButttonText }}</span>
        </div>
      </button>
    </div>
    @if (canReset) {
      <div>
        <button
          mat-button
          class="celo-hoverable"
          (click)="resetLink.emit(link)"
        >
          <div class="content">
            <mat-icon svgIcon="ic-reset"></mat-icon>
            <span>&nbsp;&nbsp;Reset invite link</span>
          </div>
        </button>
      </div>
    }
  </div>
</div>
